import api from './api';

const accountService = {
  getDeletionRequests: (params = {}) => api.get('/admin/deletion-requests', { params }),
  updateDeletionRequest: (id, body) => api.put(`/admin/deletion-requests/${id}`, body),
};

export default accountService;
